<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="tiptapRichTextDisplay no-localize-translate"
    v-html="value"
  />
</template>

<script>
export default {
  name: 'TipTapRichtextDisplay',

  props: {
    value: {
      type: String,
      default: '',
    },
  },
}
</script>

<style>
.tiptap p.is-editor-empty:first-child::before {
  color: #adb5bd;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}
.ProseMirror:focus {
  outline: none;
}

.tiptapRichTextDisplay ul,
.tiptapRichTextDisplay ol {
  padding: 0 1rem;
}

.mention {
  border-radius: 0.4rem;
  padding: 0.1rem 0.3rem;
  color: #218579;
  background-color: #e9f3f2;
}

.tiptapRichTextDisplay a {
  color: #68cef8;
}

.tiptapRichTextDisplay a:hover {
  background-color: #e9f3f2;
}

.tiptapRichTextDisplay ul,
.tiptapRichTextDisplay ol {
  list-style: revert;
}
</style>
